import React, { Fragment } from 'react'
import PaginatedConnectionTable from 'components/PaginatedConnectionTable'
import withConnectionQuery from 'components/withConnectionQuery'
import graphqlQuery from 'graphs/queries/UserCompanies.graphql'
import fields from 'fields/companies'

const RouteUserCompanies = ({ history, ...props }) => (
  <Fragment>
    <PaginatedConnectionTable
      {...props}
      history={history}
      fields={fields}
      onRowClick={(e, row) => history.push(`/admin/companies/${row.id}`)}
      showNew
      showManage
    />
  </Fragment>
)

export default withConnectionQuery({
  graphqlQuery,
  paginated: true,
  namespace: 'user.companies'
})(RouteUserCompanies)



// WEBPACK FOOTER //
// ./src/routes/admin/users/companies/index.js